import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const checkBackendHealth = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/health-check`);
    return response.status === 200;
  } catch (error) {
    console.error('Erreur de connexion au backend:', error);
    return false;
  }
}; 